import { connect } from 'react-redux'
import CloseButton from './CloseButton'
import { closePage, clearStompunkt } from '../../actionCreators'

const mapStateToProps = (state, ownProps) => ({
	type: closeButtonType(state)
})

function closeButtonType(state) {
	if (state.currentPage.length > 1) {
		return 'BACK'
	}
	else if (state.layout === 'NARROW') {
		return 'CLOSE'
	}
	else {
		return 'NONE'
	}
}

const mapDispatchToProps = (dispatch, ownProps) => ({
	onClick: () => {
		dispatch(closePage());
		dispatch(clearStompunkt());
	}
})

export default connect(mapStateToProps, mapDispatchToProps)(CloseButton)


// WEBPACK FOOTER //
// ./src/components/Page/CloseButtonContainer.js